import React, { Component } from 'react';
import { DatePicker, Icon } from 'antd';
import moment from 'moment';

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

class Datepicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            dateData: {
                'value': new Date()
            }
        };
    }
    componentDidMount() {
        this.setState((state) => ({ 'dateData': this.props.feild_data }));
    }

    onChangeDate(value, dateString) {
        console.log(value, dateString);
        this.setState({ 'value': dateString }, () => {
            this.inputBlur();
        });

    }
    inputBlur(value2) {
        console.log(value2)
        let { value, error } = this.state;
        let { feild_data } = this.props;
        feild_data['value'] = value;
        feild_data['error'] = error;
        this.props.inputChange(feild_data)
    }

    defaultDate() {
        let value = this.state.dateData.value;

        if (value !== null && value !== undefined && value !== '') {
            return moment('2015-01-07');
        } else {
            return null;
        }
    }


    render() {
        let { value, disable } = this.state.dateData;
        // let value = this.state.dateData.value;
        let { feild_data } = this.props;
        if (feild_data.name === 'estimated_admission_date') {
            return (
                <React.Fragment>
                    <div className={`${feild_data.className ? feild_data.className : 'col-12'}`}>
                        <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label>
                        {feild_data.visible &&
                            <DatePicker
                                disabled={disable}
                                disabledDate={current => {
                                    return current && current < moment().subtract(1, 'day');
                                }}
                                // disabledDate={current => {
                                //     const yesterday = moment().subtract(1, "day");
                                //     return current.isBefore(yesterday);
                                // }}
                                value={(feild_data.value !== undefined && feild_data.value !== null && feild_data.value !== '') ? moment(feild_data.value) : null}
                                placeholder={feild_data.placeholder}
                                onChange={this.onChangeDate.bind(this)} />}
                         {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} id={'errorm'+feild_data.name} className="form-text text-danger">{error.message}</small>);
                                })}
                    </div>
                </React.Fragment>
            );
        } else if (feild_data.name === 'date_of_surgery') {
            return (<React.Fragment>
                <div className={`${feild_data.className ? feild_data.className : 'col-12'}`}>
                    <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label>
                    {feild_data.visible && <DatePicker
                        disabled={disable}
                        disabledDate={current => {
                            return current && current < moment().subtract(1,'day');
                        }}
                        value={(feild_data.value !== undefined && feild_data.value !== null && feild_data.value !== '') ? moment(feild_data.value) : null}
                        placeholder={feild_data.placeholder}
                        onChange={this
                            .onChangeDate
                            .bind(this)} />}
                     {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} id={'errorm'+feild_data.name} className="form-text text-danger">{error.message}</small>);
                                })}
                </div>
            </React.Fragment>);

        } 
        else if (feild_data.name === 'call_log_back_date'||feild_data.name === 'call_log_estimated_admission_date') {
            return (<React.Fragment>
                <div className={`${feild_data.className ? feild_data.className : 'col-12'}`}>
                    <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label>
                    {feild_data.visible && <DatePicker
                        disabled={disable}
                        disabledDate={current => {
                            return current && current < moment().add(0,'day');
                        }}
                        value={(feild_data.value !== undefined && feild_data.value !== null && feild_data.value !== '') ? moment(feild_data.value) : null}
                        placeholder={feild_data.placeholder}
                        onChange={this
                            .onChangeDate
                            .bind(this)} />}
                     {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} id={'errorm'+feild_data.name} className="form-text text-danger">{error.message}</small>);
                                })}
                </div>
            </React.Fragment>);

        }  else if (feild_data.name === 'call_log_date_of_surgery') {
            return (<React.Fragment>
                <div className={`${feild_data.className ? feild_data.className : 'col-12'}`}>
                    <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label>
                    {feild_data.visible && <DatePicker
                        disabled={disable}
                        disabledDate={current => {
                            return current && feild_data.EDA? current< moment(feild_data.EDA):current < moment().add(0,'day');
                        }}
                        value={(feild_data.value !== undefined && feild_data.value !== null && feild_data.value !== '') ? moment(feild_data.value) : null}
                        placeholder={feild_data.placeholder}
                        onChange={this
                            .onChangeDate
                            .bind(this)} />}
                     {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} id={'errorm'+feild_data.name} className="form-text text-danger">{error.message}</small>);
                                })}
                </div>
            </React.Fragment>);

        }
        else {
            return (<React.Fragment>
                <div className={`${feild_data.className ? feild_data.className : 'col-12'}`}>
                    <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label>
                    {feild_data.visible && <DatePicker
                        disabled={disable}
                        value={(feild_data.value !== undefined && feild_data.value !== null && feild_data.value !== '') ? moment(feild_data.value) : null}
                        placeholder={feild_data.placeholder}
                        onChange={this
                            .onChangeDate
                            .bind(this)} />}
                     {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} id={'errorm'+feild_data.name} className="form-text text-danger">{error.message}</small>);
                                })}
                </div>
            </React.Fragment>);
        }
    }
}

export default Datepicker;
